import mixpanel from "mixpanel-browser";

const useSlideCartMixpanelHook = () => {
    function trackCartFeature({ cta = "", ctaType = "", featName = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Feature Name": featName || "-",
        };
        console._log("slideCart: Cart Feature", temp);
        mixpanel.track("Slide Cart Feature", temp);
    }

    function trackCartTopBar({ cta = "", ctaType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        console._log("slideCart: Cart Top Bar", temp);
        mixpanel.track("Slide Cart TopBar", temp);
    }

    return {
        trackCartFeature,
        trackCartTopBar,
    };
};

export default useSlideCartMixpanelHook;
